'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var reactIntl = require('react-intl');
var Highcharts = _interopDefault(require('highcharts'));
var highchartsMore = _interopDefault(require('highcharts/highcharts-more'));
var solidGauge = _interopDefault(require('highcharts/modules/solid-gauge'));
var HighchartsReact = _interopDefault(require('highcharts-react-official'));
var LoadingSpinner = require('../../LoadingSpinner/LoadingSpinner.js');
var utils = require('./utils.js');

highchartsMore(Highcharts);
solidGauge(Highcharts);
var BarChart = function (props) {
    var _a = props.autorotation, autorotation = _a === void 0 ? [-45] : _a, categories = props.categories, _b = props.color, color = _b === void 0 ? '#6E84A3' : _b, dataSeries = props.dataSeries, goal = props.goal, goalNameOverride = props.goalNameOverride, _c = props.height, height = _c === void 0 ? null : _c, _d = props.noLegend, noLegend = _d === void 0 ? false : _d, yAxisAddon = props.yAxisAddon, _e = props.yAxisLabels, yAxisLabels = _e === void 0 ? true : _e, tooltipFormatter = props.tooltipFormatter, xAxisYOffset = props.xAxisYOffset, xAxisXOffset = props.xAxisXOffset, _f = props.loading, loading = _f === void 0 ? false : _f;
    var theme = core.useTheme();
    var fm = reactIntl.useIntl().formatMessage;
    var options = utils.generateOptions({
        height: height,
        autorotation: autorotation,
        categories: categories,
        xAxisXOffset: xAxisXOffset,
        xAxisYOffset: xAxisYOffset,
        color: color,
        goal: goal,
        goalName: goalNameOverride !== null && goalNameOverride !== void 0 ? goalNameOverride : fm({ id: 'componentLib.appWide.goal' }),
        dataSeries: dataSeries,
        yAxisAddon: yAxisAddon,
        yAxisLabels: yAxisLabels,
        noLegend: noLegend,
        tooltipFormatter: tooltipFormatter,
    }, theme);
    return (React__default.createElement(LoadingSpinner, { isLoading: loading },
        React__default.createElement(HighchartsReact, { highcharts: Highcharts, options: options })));
};

module.exports = BarChart;
